import topic from '../topic'
export const msotAPI = {
    getMsots: topic.msotTopic + '/get_msots',
    getMsotById: topic.msotTopic + '/get_msot_by_id',
    addMsot: topic.msotTopic + '/add_msot',
    editMsot: topic.msotTopic + '/edit_msot',
    deleteMsotByIds: topic.msotTopic + '/delete_msot_by_ids'
}